/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Foreignlanguages_Westfriesisch2Inputs */

const en__field__enum_foreignlanguages_westfriesisch2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Westfriesisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Westfriesisch`)
};

const de__field__enum_foreignlanguages_westfriesisch2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Westfriesisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Westfriesisch`)
};

/**
* | output |
* | --- |
* | "Westfriesisch" |
*
* @param {_Field__Enum_Foreignlanguages_Westfriesisch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_foreignlanguages_westfriesisch2 = /** @type {((inputs?: _Field__Enum_Foreignlanguages_Westfriesisch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Foreignlanguages_Westfriesisch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_foreignlanguages_westfriesisch2(inputs)
	return de__field__enum_foreignlanguages_westfriesisch2(inputs)
});
export { _field__enum_foreignlanguages_westfriesisch2 as "_field__enum_foreignLanguages_Westfriesisch" }